function normalizeDuration(raw) {
  if (raw === '' || raw === null || typeof raw === 'undefined') return null
  const n = Number(raw)
  return Number.isFinite(n) && n >= 0 ? n : null
}

export function createEmptyNodePromptSection(id = 1) {
  return {
    id,
    text: '',
    duration: null,
  }
}

export function normalizeNodePromptSections(sections) {
  const list = Array.isArray(sections) ? sections : []
  const next = list
    .map((section, idx) => {
      const id = section?.id
      const hasId = typeof id === 'string' || typeof id === 'number'
      return {
        id: hasId ? id : idx + 1,
        text: typeof section?.text === 'string' ? section.text : '',
        duration: normalizeDuration(section?.duration),
      }
    })
    .filter(Boolean)

  return next.length ? next : [createEmptyNodePromptSection()]
}

export function createEmptyNodePromptDraft() {
  return {
    text: '',
    sections: [createEmptyNodePromptSection()],
  }
}

export function normalizeNodePromptDraft(draft) {
  const next = draft && typeof draft === 'object' ? draft : {}
  return {
    text: typeof next.text === 'string' ? next.text : '',
    sections: normalizeNodePromptSections(next.sections),
  }
}

export function nodePromptDraftEquals(a, b) {
  const left = normalizeNodePromptDraft(a)
  const right = normalizeNodePromptDraft(b)

  if (left.text !== right.text) return false
  if (left.sections.length !== right.sections.length) return false

  for (let i = 0; i < left.sections.length; i += 1) {
    const l = left.sections[i]
    const r = right.sections[i]
    if (l.id !== r.id) return false
    if (l.text !== r.text) return false
    if (l.duration !== r.duration) return false
  }

  return true
}
